import script from "./ApprovalsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApprovalsView.vue?vue&type=script&setup=true&lang=ts"

import "./ApprovalsView.vue?vue&type=style&index=0&id=9e9e10e0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e9e10e0"]])

export default __exports__